export default __webpack_public_path__ + "static/media/undraw_factory_dy0a.550dcdc3.svg";